import React, { createContext, useContext, useState, useEffect } from 'react';
import { ThemeProvider } from '@mui/material/styles';
import { CssBaseline } from '@mui/material';
import { lightTheme, darkTheme } from './theme';

const ThemeContext = createContext({
  themeMode: 'system',
  setThemeMode: () => {},
});

export const useTheme = () => useContext(ThemeContext);

export const ThemeProviderWrapper = ({ children }) => {
  const [themeMode, setThemeMode] = useState(() => {
    // Only use localStorage if user has explicitly set a theme
    const savedTheme = localStorage.getItem('theme');
    return savedTheme || 'system';
  });

  const [isDarkMode, setIsDarkMode] = useState(() => {
    // Always check system preference first
    const systemPrefersDark = window.matchMedia('(prefers-color-scheme: dark)').matches;
    if (themeMode === 'system') {
      return systemPrefersDark;
    }
    return themeMode === 'dark';
  });

  useEffect(() => {
    // Only save to localStorage if user has explicitly chosen a theme
    if (themeMode !== 'system') {
      localStorage.setItem('theme', themeMode);
    } else {
      localStorage.removeItem('theme');
    }
    
    const mediaQuery = window.matchMedia('(prefers-color-scheme: dark)');
    const handleChange = (e) => {
      if (themeMode === 'system') {
        setIsDarkMode(e.matches);
      }
    };

    if (themeMode === 'system') {
      setIsDarkMode(mediaQuery.matches);
      mediaQuery.addEventListener('change', handleChange);
    } else {
      setIsDarkMode(themeMode === 'dark');
    }

    return () => mediaQuery.removeEventListener('change', handleChange);
  }, [themeMode]);

  return (
    <ThemeContext.Provider value={{ themeMode, setThemeMode, isDarkMode }}>
      <ThemeProvider theme={isDarkMode ? darkTheme : lightTheme}>
        <CssBaseline />
        {children}
      </ThemeProvider>
    </ThemeContext.Provider>
  );
}; 